import messages, { locale } from './../languages/languageConfig';
import { createIntl } from 'react-intl';
export const intl = createIntl({ locale, messages });
